// extracted by mini-css-extract-plugin
export default {"navItem":"NavigationItem_navItem__eyOXZ","labelContainer":"NavigationItem_labelContainer__NdmzQ"};